import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Drag = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M7.506 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M13.006 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M7.506 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M13.006 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M7.506 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 0 1-3.5 0z'
          fill='currentColor'
        />
        <path
          d='M13.006 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 1 1-3.5 0z'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <path
          d='M7.506 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M13.006 5.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M7.506 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M13.006 18.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0'
          fill='currentColor'
        />
        <path
          d='M7.506 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 0 1-3.5 0z'
          fill='currentColor'
        />
        <path
          d='M13.006 11.9a1.75 1.75 0 1 1 3.5 0v.1a1.75 1.75 0 1 1-3.5 0z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
